<template>
  <v-form ref="form" v-on:submit.prevent="submit" v-model="valid">
    <v-card elevation="0">
      <v-card-text>
        <v-container grid-list-xl fluid>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <v-select
                :items="masters.processTypes"
                v-model="params.process_type"
                :loading="loading"
                label="Tipo de proceso"
                item-value="id"
                item-text="name"
                @change="fieldErrors.process_type = []"
                @input="processTypeChanged"
                :error-messages="fieldErrors.process_type"
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                :items="masters.materials"
                v-model="params.material"
                :loading="loading"
                label="Materia Prima"
                item-value="id"
                item-text="name"
                :disabled="!params.process_type"
                @change="fieldErrors.material = []"
                :error-messages="fieldErrors.material"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <date-picker
                :date.sync="params.start"
                @change="fieldErrors.start = []"
                :error-messages="fieldErrors.start"
                label="Desde"/>
            </v-flex>
            <v-flex xs12 sm6>
              <date-picker
                :date.sync="params.end"
                @change="fieldErrors.end = []"
                :error-messages="fieldErrors.end"
                label="Hasta"/>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*campos obligatorios</small>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn
          large
          depressed
          color="accent"
          type="submit"
          :loading="loading"
          >
            Generar informe
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import api from '@/api/app'

import formMixin from '@/mixins/formMixin'

export default {
  mixins: [formMixin],
  mounted () {
    this.loading = true

    api.getProcessTypes().then(response => {
      this.masters.processTypes = response
    }).then(() => {
      this.loading = false
    })
  },
  data () {
    return {
      tab: null,
      masters: {},
      params: {},
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null
    }
  },
  methods: {
    onSubmit () {
      return api.report('productividad', this.params)
    },
    onSuccess (response) {
      window.location.href = response['download_url']
    },
    loadProcessTypeMaterials (processType) {
      return api.getProcessTypeRawMaterials(processType).then(response => {
        this.masters.materials = response
      })
    },
    processTypeChanged () {
      this.params.material = null
      this.loading = true

      this.loadProcessTypeMaterials(this.params.process_type).then(() => {
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/partials/ProductionReport.vue